import React, { useState } from "react";
import { InputLabel, MenuItem, Select } from "@mui/material";
import "./searchBar.scss";
import FormControl from "@mui/material/FormControl";

export default function DropDownSearch({ option, handleChange, placeholder }) {
  const [selected, setSelected] = useState("");
  return (
    <div className="search-container">
      <FormControl fullWidth className="search-form">
        <InputLabel
          className="DropDownSearch-label"
          labelid="demo-multiple-name-label"
          id="demo-multiple-name-label"
        >
          {placeholder}
        </InputLabel>
        <Select
          className="input-drop-select"
          value={selected}
          onChange={(event) => {
            handleChange(event.target.value);
            setSelected(event.target.value);
          }}
          inputProps={{ "aria-label": "Without label" }}
        >
          {option?.map((index) => {
            return (
              <MenuItem key={index.name} value={index?.name} selected={true}>
                {index?.name?.charAt(0).toUpperCase() + index?.name?.slice(1)}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}
